export default __webpack_public_path__ + "static/mastercard-3e9c8bda18ab98f44cf6a10e4ed3d7e8.svg";